module.exports = __webpack_public_path__ + "static/media/wash-and-press-service.b042a924.webp";